<template>
  <v-container>
    <v-row
      align="center"
      class="mb-10"
    >
      <v-col>
        <span>Список: ({{ listItem.data.pills.length }})</span>
        <ErrorMessage :message="errorMessages.pills"/>
      </v-col>
      <v-spacer/>
      <v-btn
        class="mr-2"
        small
        :disabled="isLoading"
        :loading="isLoading"
        @click="mixAddListItemItemHandler('pills', $options.widgetItems)"
      >
        <v-icon small> mdi-plus </v-icon>
      </v-btn>
    </v-row>
    <v-row
      align="center"
      class="mb-5"
      v-for="(listItemItem, listItemItemIndex) in listItem.data.pills"
      :key="listItemItemIndex"
    >
      <v-card flat color="transparent">
        <v-card-title>Кнопка {{ listItemItemIndex+1 }}:</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <span>Текст (<TranslationIcon/>)</span>
              <v-text-field
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.title"
                :error-messages="errorMessages[listItemItemIndex] ? errorMessages[listItemItemIndex].title : ''"
                @input="mixChangeListItemItemHandler($event, 'pills', listItemItemIndex, 'title')"
              />
            </v-col>
            <v-col cols="6">
              <span>Подзаголовок (<TranslationIcon/>)</span>
              <v-text-field
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.subTitle"
                :error-messages="errorMessages[listItemItemIndex] ? errorMessages[listItemItemIndex].subTitle : ''"
                @input="mixChangeListItemItemHandler($event, 'pills', listItemItemIndex, 'subTitle')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span>Код иконки</span>
              <v-text-field
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.iconCode"
                :error-messages="errorMessages[listItemItemIndex] ? errorMessages[listItemItemIndex].iconCode : ''"
                @input="mixChangeListItemItemHandler($event, 'pills', listItemItemIndex, 'iconCode')"
              />
            </v-col>
            <v-col cols="6">
              <span>Ссылка</span>
              <v-text-field
                outlined
                :disabled="isLoading"
                :loading="isLoading"
                :value="listItemItem.data.link"
                :error-messages="errorMessages[listItemItemIndex] ? errorMessages[listItemItemIndex].link : ''"
                @input="mixChangeListItemItemHandler($event, 'pills', listItemItemIndex, 'link')"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card flat color="transparent">
        <v-card-text>
          <v-btn
            class="mr-2"
            small
            :disabled="isLoading"
            :loading="isLoading"
            @click="mixRemoveListItemItemHandler(listItemItemIndex, 'pills')"
          >
            <v-icon color="red">mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import { widgetItems } from '@/utils/widgets/widgetsTypes.js'
import ErrorMessage from '@/components/error-messages/ErrorMessage'
import TranslationIcon from '@/components/translation-icon/translationIcon'
export default {
  name: 'NavPillsLargeWidget',
  components: { TranslationIcon, ErrorMessage },
  widgetItems,
  mixins: [dynamicListItemMix]
}
</script>
